import { Validator } from 'vee-validate'
import { validaNome } from '@/shared/common/functions/texto'

Validator.localize('pt')

Validator.extend('nome-valido', {
    getMessage: 'Digite ao menos 3 caracteres, incluindo letras',
    validate: ((nome) => {
        return validaNome(nome)
    })
});
